import ResultHeader from "../Table/ResultHeader";
import ResultRow from "../Table/ResultRow";
import ResultHeaderCell from "../Table/ResultHeaderCell";
import ResultBody from "../Table/ResultBody";
import getSettingsItem, {getSettingsSelectItem} from "./SettingsItem";
import ResultTable from "../Table/ResultTable";
import {Select} from "antd";

export default function WSELLibrary({onValuesChange, values, defValues}) {

    return (
        <>
            <ResultTable>
                <ResultHeader>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left', width: 300}}>Variable</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'left', width: 115}}>User Preference</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'left', width: 115}}>System Default</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'left', width: 230}}>Description</ResultHeaderCell>
                    </ResultRow>
                </ResultHeader>
                <ResultBody>
                    {
                        getSettingsItem({
                            value: values?.tnm_tolerance,
                            defaultValue: defValues?.tnm_tolerance,
                            onChange: (value) => {onValuesChange('tnm_tolerance', value)},
                            label: 'Target Not Met tolerance (ft)',
                            description: 'G7'
                        })
                    }
                    {
                        getSettingsSelectItem({
                            value: values?.tnm_adjustment,
                            defaultValue: defValues?.tnm_adjustment,
                            onChange: (value) => {onValuesChange('tnm_adjustment', value)},
                            label: 'Target Not Met Profile Adjustment',
                            description: 'G5(Low, High, Interpolate)',
                            options: (
                                <>
                                    <Select.Option value={'interpolate'}>
                                        Interpolate
                                    </Select.Option>
                                    <Select.Option value={'min'}>
                                        Min
                                    </Select.Option>
                                    <Select.Option value={'max'}>
                                        Max
                                    </Select.Option>
                                </>
                            )
                        })
                    }
                    {
                        getSettingsSelectItem({
                            value: values?.crossing_adjustment,
                            defaultValue: defValues?.crossing_adjustment,
                            onChange: (value) => {onValuesChange('crossing_adjustment', value)},
                            label: 'Crossing Profile Adjustment',
                            description: 'G5(Low, High, Interpolate)',
                            options: (
                                <>
                                    <Select.Option value={'low'}>
                                        Low
                                    </Select.Option>
                                    <Select.Option value={'high'}>
                                        High
                                    </Select.Option>
                                    <Select.Option value={'interpolate'}>
                                        Interpolate
                                    </Select.Option>
                                </>
                            )
                        })
                    }
                    {
                        getSettingsSelectItem({
                            value: values?.choking_adjustment,
                            defaultValue: defValues?.choking_adjustment,
                            onChange: (value) => {onValuesChange('choking_adjustment', value)},
                            label: 'Choking Cross Section Adjustment',
                            description: 'G4(DS, US, Interpolate)',
                            options: (
                                <>
                                    <Select.Option value={'ds'}>
                                        DS
                                    </Select.Option>
                                    <Select.Option value={'us'}>
                                        US
                                    </Select.Option>
                                    <Select.Option value={'interpolate'}>
                                        Interpolate
                                    </Select.Option>
                                </>
                            )
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.bridge_fb,
                            defaultValue: defValues?.bridge_fb,
                            onChange: (value) => {onValuesChange('bridge_fb', value)},
                            label: 'Bridge Freeboard threshold (ft)',
                            description: 'G7'
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.culvert_fb,
                            defaultValue: defValues?.culvert_fb,
                            onChange: (value) => {onValuesChange('culvert_fb', value)},
                            label: 'Culvert Freeboard threshold (ft)',
                            description: 'G7'
                        })
                    }
                </ResultBody>
            </ResultTable>
        </>
    )
}